import {
    Wrapper,
    ClaimExperienceContainer,
    ExperienceItem,
    ImageItem,
    Title,
    ClaimItemWrapper,
    ClaimItemText,
    ClaimItemIconWrapper,
} from './styles';
import Image from 'next/image';
import { getImageBasePath } from '@utils/generics';

interface IProps {
    isMobile: boolean;
}

const claimItems = [
    'All-digital process for a hassle-free experience',
    '3-step claim procedure for a smooth customer journey',
    'Real-time tracking to stay updated and manage claim status',
    'Exceptional turnaround time of 3-5 working days',
];

const ClaimItem = ({ text }) => {
    return (
        <ClaimItemWrapper>
            <ClaimItemIconWrapper>
                <Image
                    src={getImageBasePath('/icons/listBullet.svg')}
                    height="24px"
                    width="24px"
                />
            </ClaimItemIconWrapper>
            <ClaimItemText>{text}</ClaimItemText>
        </ClaimItemWrapper>
    );
};

const ClaimExperience = ({ isMobile }: IProps) => {
    return (
        <Wrapper>
            <ClaimExperienceContainer>
                <ExperienceItem>
                    <Title>Claim Experience with ACKO</Title>
                    {claimItems.map((item, i) => {
                        return <ClaimItem key={i} text={item} />;
                    })}
                </ExperienceItem>
                <ImageItem>
                    <Image
                        src={getImageBasePath(
                            isMobile
                                ? '/images/mobileClaimExperience.svg'
                                : '/images/claimExperience.svg'
                        )}
                        height={isMobile ? '1000px' : '510px'}
                        width={isMobile ? '540px' : '720px'}
                    />
                </ImageItem>
            </ClaimExperienceContainer>
        </Wrapper>
    );
};

export default ClaimExperience;
